import React from 'react';
import LazyMedia from '../LazyMedia';
import '../../assets/css/Header.css';

function Header({ type = 'main' }) {
    const headerTextMap = {
        main: "Se former pour sauver",
    };
    const headerText = headerTextMap[type] || headerTextMap.main;

    // Générer les résolutions disponibles pour le srcset
    const resolutions = [320, 640, 1024, 1280, 1920]; // Les tailles d'image possibles
    const srcBase = `banners/banner_formation.webp`;

    return (
        <header className="header-container">
            <div className="header-background">
                <LazyMedia
                    type="image"
                    src={srcBase}
                    alt={`Bannière ${type}`}
                    className="header-image"
                    critical
                    resolutions={resolutions} // Passer les résolutions pour le srcset
                />
            </div>
            <div className="overlay">
                <h1 className="header-text">{headerText}</h1>
            </div>
        </header>
    );
}

export default Header;
